import {
  Alert,
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'
import {
  BibliographyClass,
  CollectionFlag,
  defaultReceiptPrintReceiptCollectionStatusConfirmData,
  Prefix,
  ReceiptCollectionStatusConfirmDataFromJSON,
  ReceiptPrintReceiptCollectionStatusConfirmData
} from '@/types'

export interface LendCollectionList {
  collectionId: number
  collectionNo: string
  parentComposedCollectionId: number
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  appendixCode: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  collectionStatus: SystemCode
  workMemo: string
  displayMemo: string
  localMemo: string
  dueDate: string
  hasReservation: boolean
  hasReserveForwarding: boolean
  collectionFlag: CollectionFlag
  appendixLendFlag: boolean
  lendUserId: string
  lendClassification: string
  _deleteHandlingType: boolean // レスポンスとして送られてきている値ではないが、別apiで使用したいので設定
  shelfType: SystemCode
  revision: number
  messages: Alert[]
  branch: SystemCode // 通常の貸出資料取得レスポンスでは送られていない値
  lendUserReserveWaitingId: number
  lendUserReserveWaitingRevision: number
  receiptCollectionStatusInfo: ReceiptPrintReceiptCollectionStatusConfirmData
}

export function LendCollectionListFromJSON(json: any): LendCollectionList {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    parentComposedCollectionId: exists(json, 'parent_composed_collection_id')
      ? json.parent_composed_collection_id
      : 0,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    workMemo: exists(json, 'work_memo') ? json.work_memo : '',
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    localMemo: exists(json, 'local_memo') ? json.local_memo : '',
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    hasReservation: exists(json, 'has_reservation')
      ? json.has_reservation
      : false,
    hasReserveForwarding: exists(json, 'has_reserve_forwarding')
      ? json.has_reserve_forwarding
      : false,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    appendixLendFlag: exists(json, 'appendix_lend_flag')
      ? json.appendix_lend_flag
      : false,
    lendUserId: exists(json, 'lend_user_id') ? json.lend_user_id : '',
    lendClassification: exists(json, 'lend_classification')
      ? json.lend_classification
      : '',
    _deleteHandlingType: false,
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0,
    messages: exists(json, 'messages') ? json.messages : [],
    branch: exists(json, 'branch')
      ? SystemCodeFromJSON(json.branch)
      : defaultSystemCode(),
    lendUserReserveWaitingId: exists(json, 'lend_user_reserve_waiting_id')
      ? json.lend_user_reserve_waiting_id
      : 0,
    lendUserReserveWaitingRevision: exists(
      json,
      'lend_user_reserve_waiting_revision'
    )
      ? json.lend_user_reserve_waiting_revision
      : 0,
    receiptCollectionStatusInfo: exists(json, 'receipt_collection_status_info')
      ? ReceiptCollectionStatusConfirmDataFromJSON(
          json.receipt_collection_status_info
        )
      : defaultReceiptPrintReceiptCollectionStatusConfirmData()
  }
}
